import { seoFor } from "@/lib/i18n/keywordPools";
import { createFileRoute } from "@tanstack/react-router";
import HistoricalOdds from "@/pages/HistoricalOdds";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/historical-odds")({
  head: () => ({
    meta: [
      { title: "Historical Odds & Results Archive | Statlign" },
      { name: "keywords", content: seoFor({ topics: ["trackRecord"] }).meta },
      { name: "description", content: "Browse historical football odds, closing lines and past results to research value trends and back-test betting strategies with Statlign's data archive." },
      { property: "og:title", content: "Historical Odds & Results Archive | Statlign" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "Browse historical football odds, closing lines and past results to research value trends and back-test betting strategies with Statlign's data archive." },
      { name: "twitter:title", content: "Historical Odds & Results Archive | Statlign" },
      { name: "twitter:description", content: "Browse historical football odds, closing lines and past results to research value trends and back-test betting strategies with Statlign's data archive." },
    ],
  }),
  component: () => (
    <MainLayout>
      <HistoricalOdds />
    </MainLayout>
  ),
});
